import '../stylus/style.styl'
import mitt from 'mitt'

window.emitter = mitt()

import App from './app/App.js'
import { onLoad } from './loading/OnLoad.js'

//=======================
// SITE LOADING
//=======================

// Start app when document ready
document.addEventListener('DOMContentLoaded', () => {
	onLoad()
	new App()
})